import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/logo-transparent.png'


const _hoisted_1 = { class: "min-h-screen bg-gray-50 flex" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"hidden lg:flex lg:w-1/2 bg-[#1E2833] flex-col items-center justify-center p-12 relative overflow-hidden\"><div class=\"absolute inset-0 opacity-10\" style=\"background-image:repeating-linear-gradient(45deg, transparent, transparent 20px, rgba(108,197,81,0.4) 20px, rgba(108,197,81,0.4) 21px);\"></div><div class=\"absolute top-0 left-0 w-1 h-full bg-[#6CC551]\"></div><div class=\"relative z-10 text-center\"><img src=\"" + _imports_0 + "\" alt=\"GEMA Logo\" class=\"w-20 h-20 mx-auto mb-6 drop-shadow-lg\"><h1 class=\"text-3xl font-extrabold text-white uppercase tracking-wide mb-2\">Ga East</h1><p class=\"text-[#6CC551] text-sm font-bold uppercase tracking-widest mb-6\">Municipal Assembly</p><div class=\"w-12 h-0.5 bg-[#6CC551] mx-auto mb-6\"></div><p class=\"text-gray-400 text-sm leading-relaxed max-w-xs mx-auto\"> Secure administration portal. Authorized personnel only. </p></div></div>", 1)
const _hoisted_3 = { class: "w-full lg:w-1/2 flex items-center justify-center p-8" }
const _hoisted_4 = { class: "w-full max-w-md" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"lg:hidden text-center mb-8\"><img src=\"" + _imports_0 + "\" alt=\"GEMA Logo\" class=\"w-14 h-14 mx-auto mb-3\"><p class=\"text-[#1E2833] font-extrabold text-lg uppercase tracking-wide\">Ga East Municipal Assembly</p></div><p class=\"text-[#6CC551] text-xs font-bold uppercase tracking-widest mb-2\">Admin Portal</p><h2 class=\"text-3xl font-extrabold text-[#1E2833] mb-1\">Welcome back</h2><p class=\"text-gray-400 text-sm mb-8\">Sign in to access the dashboard.</p>", 4)
const _hoisted_9 = ["onSubmit"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "username",
  class: "block text-xs font-semibold text-gray-600 mb-1.5"
}, "Username", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block text-xs font-semibold text-gray-600 mb-1.5"
}, "Password", -1)
const _hoisted_12 = {
  key: 0,
  class: "text-red-500 text-xs font-medium"
}
const _hoisted_13 = {
  key: 1,
  class: "text-[#6CC551] text-xs font-medium"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "w-4 h-4 rounded-full border-2 border-white border-t-transparent animate-spin"
}

import { ref } from "vue";
import { authService } from "@/services/auth";
import router from "@/router";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const username       = ref("");
const password       = ref("");
const errorMessage   = ref("");
const successMessage = ref("");
const isLoading      = ref(false);

const handleLogin = async () => {
  if (!username.value || !password.value) {
    errorMessage.value = "Please fill in all fields.";
    return;
  }

  isLoading.value    = true;
  errorMessage.value = "";
  successMessage.value = "";

  try {
    const token = await authService.login(username.value, password.value);
    if (token) {
      store.commit("login", { token, username: username.value });
      successMessage.value = "Login successful!";
      router.push("/admin/dashboard");
    } else {
      errorMessage.value = "Invalid username or password.";
    }
  } catch (err: any) {
    errorMessage.value = err.response?.data?.message || "An error occurred. Please try again.";
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("form", {
          onSubmit: _withModifiers(handleLogin, ["prevent"]),
          class: "space-y-5"
        }, [
          _createElementVNode("div", null, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "username",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
              placeholder: "Enter your username",
              required: "",
              class: "w-full px-4 py-2.5 text-sm text-gray-800 bg-white border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#6CC551]/30 focus:border-[#6CC551] transition-colors"
            }, null, 512), [
              [_vModelText, username.value]
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              type: "password",
              id: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
              placeholder: "Enter your password",
              required: "",
              class: "w-full px-4 py-2.5 text-sm text-gray-800 bg-white border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#6CC551]/30 focus:border-[#6CC551] transition-colors"
            }, null, 512), [
              [_vModelText, password.value]
            ])
          ]),
          (errorMessage.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(errorMessage.value), 1))
            : _createCommentVNode("", true),
          (successMessage.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(successMessage.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "submit",
            disabled: isLoading.value,
            class: "w-full py-2.5 bg-[#6CC551] hover:bg-green-600 disabled:opacity-60 disabled:cursor-not-allowed text-white text-sm font-semibold rounded-xl transition-colors flex items-center justify-center gap-2"
          }, [
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(isLoading.value ? 'Signing in…' : 'Sign In'), 1)
          ], 8, _hoisted_14)
        ], 40, _hoisted_9)
      ])
    ])
  ]))
}
}

})